var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1673 10.9997C20.1673 16.0622 16.0632 20.1663 11.0007 20.1663C5.93804 20.1663 1.83398 16.0622 1.83398 10.9997C1.83398 5.93706 5.93804 1.83301 11.0007 1.83301C16.0632 1.83301 20.1673 5.93706 20.1673 10.9997Z",
    stroke: "#292929",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 11.4584C14.6673 11.4584 11.9668 15.125 11.0007 15.125C10.0344 15.125 7.33398 11.4583 7.33398 11.4583M11.0007 14.6666V6.875",
    stroke: "#292929",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3e4ced25069c20c049da7b74a4c90316.svg";
export { ForwardRef as ReactComponent };